import {
  Box,
  Container,
  FormControl,
  Grid,
  InputLabel,
  Select,
  TextField,
  Paper,
  Dialog,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Button,
  MenuItem,
  FormHelperText,
  IconButton,
  InputAdornment,
  Modal,
  Typography,
  Tooltip,
} from '@mui/material';
import moment from 'moment';
import React, { useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import TaskDatePicker from '../../components/TaskTimeAndDatePicker/DatePicker';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import DateRangeComponent from '../../components/DateRangePicker/DateRangeComponent';
import { useDispatch, useSelector } from 'react-redux';
import KeycloakService from '../../services/KeycloakService';
import { createTask, updateTask } from '../../services/TaskServices';
import dayjs from 'dayjs';
import ErrorSwitchCase from '../../services/ErrorHandlerService';
import {
  getSecondsFromHHMMSS,
  getHHMMSSFromSeconds,
} from '../../utils/TimeConversionFunctions';
import {
  CANCEL_BUTTON_TEXT,
  ERROR_KEY,
  RESET_DATE_RANGE,
  SHOW_NOTIFICATION,
  SUBMIT_BUTTON_TEXT,
} from '../../constants';
import {
  APPRAISAL,
  DURATION,
  EXTERNAL,
  EXTERNAL_HOURS,
  CLIENT_OFFICE,
  CLIENT_OFFICE_HOURS,
  WORK_TRAVEL,
  WORK_TRAVEL_HOURS,
  PROJECT,
  SET_DATE_RANGE,
  TaskFieldError,
  TASK_DESCRIPTION,
  TASK_EDIT,
  TASK_EDIT_CLOSE,
  TASK_TILE,
  TASK_TYPE,
  WFH,
  WFO,
  WORK_FROM_HOME,
  WORK_FROM_OFFICE,
  YYYY_MM_DD,
} from './TaskConstants';
import { MAIN_BLUE } from '../../color';
import './TaskField.css';
import CloseIcon from '@mui/icons-material/Close';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

import { msToTime } from '../../utils/TimeConversionFunctions';
import { getSummary } from '../../services/TimingService';
import { hoursToMilliseconds } from 'date-fns';

const TaskField = (props) => {
  const userDataState = useSelector((state) => state.taskOperation);
  const currentUserId = KeycloakService.getUserDetail();
  const {
    userProjects,
    handleClose,
    getTask,
    editData,
    setSelectedTaskData,
    rows,
    dialogBoxRef,
    setPage,
    setPageNo,
    monthlyQuotaAllottedInMS,
    monthlyQuotaAvailedInMS,
    clientOfficeMonthlyQuotaAllottedInMS = 0,
    clientOfficeMonthlyQuotaAvailedInMS = 0,
    workTravelMonthlyQuotaAllottedInMS = 0,
    workTravelMonthlyQuotaAvailedInMS = 0,
    quotaDetails,
    clientOfficeQuotaDetails,
    workTravelQuotaDetails,
  } = props;

  const [taskFormData, setTaskFormData] = React.useState({
    project: '',
    taskType: '',
    taskTitle: '',
    description: '',
    startDate: '',
    endDate: '',
  });

  const [fieldError, setFieldError] = React.useState({
    project: false,
    taskType: false,
    taskTitle: false,
    timeDuration: false,
  });
  const [errorMsg, setErrorMsg] = React.useState({
    project: '',
    taskType: '',
    taskTitle: '',
    timeDuration: '',
  });

  const [appraisal, setAppraisal] = React.useState(false);
  const [time, setTime] = React.useState('00:00');
  const [timepickerField, setTimepickerField] = React.useState(null);
  const [timepickerFieldMulti, setTimepickerFieldMulti] = React.useState([
    null,
  ]);

  const [currentDate, setCurrentDate] = React.useState({
    date: userDataState.edit
      ? dayjs(editData.startDate)
      : dayjs(moment(new Date()).format(YYYY_MM_DD)),
  });
  const [multipleTasks, setMultipleTasks] = React.useState([
    {
      date: moment(new Date()).format(YYYY_MM_DD),
      timings: [
        {
          date: moment(new Date()).format(YYYY_MM_DD),
          title: '',
          description: '',
          officeHours: null,
          wfhHours: 0,
          externalHours: 0,
          clientOfficeHours: 0,
          timeError: false,
          timeErrorMsg: '',
          titleError: false,
          titleErrorMsg: '',
        },
      ],
    },
  ]);
  const [dateRangeError, setDateRangeError] = React.useState(undefined);
  const [dateError, setDateError] = React.useState(undefined);
  const [timeError, setTimeError] = React.useState(undefined);
  const [timeErrorMsg, setTimeErrorMsg] = React.useState('');
  const [loadingApiCall, setLoadingApiCall] = React.useState(false);
  const [workingHoursData, setWorkingHoursData] = React.useState([
    {
      date: moment(new Date()).format(YYYY_MM_DD),
      title: '',
      description: '',
      officeHours: '00:00',
      wfhHours: 0,
      externalHours: 0,
      timeError: false,
      timeErrorMsg: '',
      titleError: false,
    },
  ]);

  const dispatch = useDispatch();

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const [dateRange, setDateRange] = React.useState([
    {
      startDate: '',
      endDate: '',
    },
  ]);
  const getExternalTime = () => {
    const newDateObj = new Date();
    newDateObj.setHours(0);
    newDateObj.setMinutes(0);
    newDateObj.setSeconds(0);
    if (timepickerField != null) {
      let timing = timepickerField;
      let timeArr = timing.split(':');
      let timeObj = new Date(
        newDateObj.getTime() +
          (parseInt(timeArr[0]) * 60 + parseInt(timeArr[1])) * 60000,
      );
      return timeObj;
    }
    return null;
  };
  const getMultiTime = (index, timingsIndex) => {
    const date = multipleTasks[index].date;
    const newDateobj = new Date(date);
    newDateobj.setHours(0);
    newDateobj.setMinutes(0);
    newDateobj.setSeconds(0);
    const set_timings = multipleTasks[index].timings[timingsIndex].officeHours;
    if (set_timings !== null) {
      let timeStr = set_timings;
      let timeArr = timeStr.split(':');
      let timeObj = new Date(
        newDateobj.getTime() +
          (parseInt(timeArr[0]) * 60 + parseInt(timeArr[1])) * 60000,
      );
      return timeObj;
    }
    return null;
  };
  const handleChangeForRangeSelection = (e, index, timingsIndex) => {
    let newTasks = [...multipleTasks];
    if (e == null)
      newTasks[index].timings[timingsIndex].officeHours = moment(
        new Date(e).setHours(0, 0, 0, 0),
      ).format('HH:mm');
    else
      newTasks[index].timings[timingsIndex].officeHours = moment(
        new Date(e),
      ).format('HH:mm');
    setMultipleTasks(newTasks);
  };

  const handleChangeForTaskTitle = (event) => {
    setTaskFormData((prevRow) => {
      return { ...prevRow, [event.target.name]: event.target.value };
    });
  };
  const handleChangeForWFOTaskTitle = (event, index, timingsIndex) => {
    let newTasks = [...multipleTasks];
    newTasks[index].timings[timingsIndex].title = event.target.value;
    if (newTasks[index].timings[timingsIndex].title !== '') {
      newTasks[index].timings[timingsIndex].titleError = false;
      newTasks[index].timings[timingsIndex].titleErrorMsg = '';
    }
    setMultipleTasks(newTasks);
  };
  const handleAddTasktoDate = (event, index) => {
    const updatedTasks = [...multipleTasks];
    updatedTasks[index].timings.push({
      date: updatedTasks[index].date,
      title: '',
      description: '',
      officeHours: null,
      wfhHours: 0,
      externalHours: 0,
      timeError: false,
      timeErrorMsg: '',
      titleError: false,
      titleErrorMsg: '',
    });
    setMultipleTasks(updatedTasks);
  };
  const handleRemoveTask = (event, index, timingsIndex) => {
    const updatedTimings = [
      ...multipleTasks[index].timings.slice(0, timingsIndex),
      ...multipleTasks[index].timings.slice(timingsIndex + 1),
    ];
    const newTasks = [
      ...multipleTasks.slice(0, index),
      { ...multipleTasks[index], timings: updatedTimings },
      ...multipleTasks.slice(index + 1),
    ];
    setMultipleTasks(newTasks);
  };
  const handleChangeForWFOTaskDescription = (event, index, timingsIndex) => {
    let newTasks = [...multipleTasks];
    newTasks[index].timings[timingsIndex].description = event.target.value;
    setMultipleTasks(newTasks);
  };
  const handleChangeForTaskType = (event) => {
    setTaskFormData({
      ...taskFormData,
      taskTitle: editData.taskType === event.target.value ? editData.title : '',
      description:
        editData.taskType === event.target.value ? editData.description : '',
    });

    setTaskFormData((prevRow) => {
      return { ...prevRow, [event.target.name]: event.target.value };
    });
  };

  const handleChangeForDescription = (event) => {
    setTaskFormData((prevRow) => {
      return { ...prevRow, [event.target.name]: event.target.value };
    });
  };
  const handleChangeForProject = (event) => {
    if (editData?.taskType === WFO) {
      if (event.target.value !== editData.projectName) {
        const updatedTasks = multipleTasks.map((item) => {
          const updatedTimings = item.timings.map((newTimings) => {
            const updatedElement = { ...newTimings };
            updatedElement.title = '';
            updatedElement.description = '';
            updatedElement.officeHours = null;
            updatedElement.wfhHours = 0;
            updatedElement.externalHours = 0;
            updatedElement.timeError = false;
            updatedElement.timeErrorMsg = '';
            updatedElement.titleError = false;
            updatedElement.titleErrorMsg = '';
            return updatedElement;
          });
          return {
            ...item,
            timings: updatedTimings,
          };
        });
        setMultipleTasks(updatedTasks);
      }
    } else if (
      editData?.taskType === EXTERNAL ||
      editData?.taskType === WORK_TRAVEL
    ) {
      if (event.target.value !== editData.projectName) {
        setTaskFormData({
          project: '',
          taskType: '',
          taskTitle: '',
          description: '',
          startDate: '',
          endDate: '',
        });
        setTime('00:00');
        setTimepickerField(null);
        setCurrentDate(moment(new Date()).format(YYYY_MM_DD));
      }
    }
    setTaskFormData((prevRow) => {
      return { ...prevRow, [event.target.name]: event.target.value };
    });
  };

  const handleOnChangeAppraisal = () => {
    setAppraisal(!appraisal);
  };

  const handleCancelForm = () => {
    dispatch({
      type: RESET_DATE_RANGE,
    });
    handleClose();
  };

  const onChangeTime = (value) => {
    setTime(moment(new Date(value)).format('HH:mm'));
    if (value == null)
      setTimepickerField(
        moment(new Date().setHours(0, 0, 0, 0)).format('HH:mm'),
      );
    else setTimepickerField(moment(new Date(value)).format('HH:mm'));
  };

  const dataValidation = () => {
    const fieldKeys = ['project', 'taskType'];

    for (let i = 0; i < fieldKeys.length; i++) {
      setFieldError({
        project: false,
        taskType: false,
        taskTitle: false,
        timeDuration: false,
      });

      setErrorMsg((prev) => {
        return {
          ...prev,
          project: '',
          taskType: '',
          taskTitle: '',
          timeDuration: '',
        };
      });

      if (!Object.values(taskFormData)[i]) {
        setFieldError((prev) => {
          return { ...prev, [fieldKeys[i]]: true };
        });
        setErrorMsg((prev) => {
          return { ...prev, [fieldKeys[i]]: `${TaskFieldError.REQUIRED}` };
        });
        return false;
      }
    }

    if (taskFormData.taskType === WFO) {
      for (let i = 0; i < multipleTasks.length; i++) {
        for (let j = 0; j < multipleTasks[i].timings.length; j++) {
          hourValidation(multipleTasks[i].timings[j].officeHours, i, j);
        }
      }
      const newTasks = multipleTasks.map((task) => {
        const updatedTimings = task.timings.map((timing) => {
          const hasTitle = timing?.title.trim() !== '';
          return {
            ...timing,
            titleError: !hasTitle,
            titleErrorMsg: hasTitle ? '' : '*Required',
          };
        });
        return {
          ...task,
          timings: updatedTimings,
        };
      });
      setMultipleTasks(newTasks);
      const hasErrors = newTasks.some((task) => {
        return task.timings.some((timing) => {
          return timing.timeError || timing?.titleError;
        });
      });

      if (!taskFormData.taskTitle.trim()) {
        setFieldError((prev) => {
          return { ...prev, taskTitle: true };
        });
        setErrorMsg((prev) => {
          return { ...prev, taskTitle: `${TaskFieldError.REQUIRED}` };
        });
        return false;
      }

      if (hasErrors) {
        return false;
      }

      return true;
    } else {
      if (hourValidation(time) == 0) {
        setFieldError((prev) => {
          return { ...prev, timeDuration: true };
        });
        return false;
      }
      if (!taskFormData.taskTitle.trim()) {
        setFieldError((prev) => {
          return { ...prev, taskTitle: true };
        });
        setErrorMsg((prev) => {
          return { ...prev, taskTitle: `${TaskFieldError.REQUIRED}` };
        });
        return false;
      }
      return true;
    }
  };

  // Per-taskType quota configuration, keyed by the hours-type discriminator.
  const QUOTA_CONFIG_BY_TASK_TYPE = {
    [CLIENT_OFFICE]: {
      timingsKey: 'clientOfficeHours',
      summaryKey: 'totalClientOfficeHours',
      details: clientOfficeQuotaDetails,
      allotted: clientOfficeMonthlyQuotaAllottedInMS,
      availed: clientOfficeMonthlyQuotaAvailedInMS,
    },
    [WORK_TRAVEL]: {
      timingsKey: 'workTravelHours',
      summaryKey: 'totalWorkTravelHours',
      details: workTravelQuotaDetails,
      allotted: workTravelMonthlyQuotaAllottedInMS,
      availed: workTravelMonthlyQuotaAvailedInMS,
    },
    [EXTERNAL]: {
      timingsKey: 'externalHours',
      summaryKey: 'totalExternalHours',
      details: quotaDetails,
      allotted: monthlyQuotaAllottedInMS,
      availed: monthlyQuotaAvailedInMS,
    },
  };

  const validationForAddingTasksForPrevMonths = async (
    startDate,
    updatedTiming,
    hoursBeforeEdit = 0,
    hoursType = EXTERNAL,
  ) => {
    const startDateObj = new Date(
      new Date(startDate).getFullYear(),
      new Date(startDate).getMonth(),
      1,
    );

    const endDateObj = new Date(
      new Date(startDate).getFullYear(),
      new Date(startDate).getMonth() + 1,
      0,
    );

    const config = QUOTA_CONFIG_BY_TASK_TYPE[hoursType] ?? QUOTA_CONFIG_BY_TASK_TYPE[EXTERNAL];
    const details = config.details;
    let allottedQuotaForSelectedMonth = 0;
    if (startDateObj.getFullYear() === new Date().getFullYear()) {
      allottedQuotaForSelectedMonth = hoursToMilliseconds(
        details?.thisYear?.[startDateObj.getMonth()],
      );
    } else {
      allottedQuotaForSelectedMonth = hoursToMilliseconds(
        details?.prevYear?.[startDateObj.getMonth()],
      );
    }

    const formattedStartDate = startDateObj.toLocaleDateString('en-CA');
    const formattedEndDate = endDateObj.toLocaleDateString('en-CA');

    const summaryData = await getSummary(
      formattedStartDate,
      formattedEndDate,
      currentUserId,
    );

    if (summaryData.isError === false) {
      const availedInSelectedMonth = summaryData?.data?.[config.summaryKey] || 0;

      const checkHrs =
        availedInSelectedMonth + updatedTiming - hoursBeforeEdit;
      return allottedQuotaForSelectedMonth >= checkHrs;
    }
  };

  const resolveQuotaCheck = async (bodyPayload, isEdit) => {
    const hoursType = QUOTA_CONFIG_BY_TASK_TYPE[bodyPayload.taskType]
      ? bodyPayload.taskType
      : EXTERNAL;
    const config = QUOTA_CONFIG_BY_TASK_TYPE[hoursType];
    const updatedTiming = bodyPayload?.timings?.[0]?.[config.timingsKey] || 0;
    const previousHours = isEdit
      ? editData?.timings?.[0]?.[config.timingsKey] || 0
      : 0;
    const allotted = config.allotted;
    const availed = config.availed;

    if (new Date(bodyPayload.startDate).getMonth() === new Date().getMonth()) {
      return allotted >= availed + updatedTiming - previousHours;
    }
    return validationForAddingTasksForPrevMonths(
      bodyPayload.startDate,
      updatedTiming,
      previousHours,
      hoursType,
    );
  };

  const handleSubmitForTask = async () => {
    //  updating the already existing task
    if (editData?.employeeId) {
      if (dataValidation()) {
        const bodyPayload = createTaskBodyJSON(taskFormData);
        let isUnderQuota = true;
        if (
          bodyPayload.taskType === EXTERNAL ||
          bodyPayload.taskType === CLIENT_OFFICE ||
          bodyPayload.taskType === WORK_TRAVEL
        ) {
          isUnderQuota = await resolveQuotaCheck(bodyPayload, true);
        }
        if (!isUnderQuota) {
          setFieldError((prev) => {
            return { ...prev, timeDuration: true };
          });
          setErrorMsg((prev) => {
            return { ...prev, timeDuration: 'Exceeds Allotted Quota' };
          });
          return;
        }
        setLoadingApiCall(true);
        const updatedTaskResponse = await updateTask(bodyPayload);
        setLoadingApiCall(false);
        if (updatedTaskResponse.isError === false) {
          dispatch({
            type: TASK_EDIT_CLOSE,
          });
          handleClose();
          getTask();
          setPageNo(0);
          setPage(1);
          setSelectedTaskData(() => {
            return {
              id: null,
              project: '',
              taskTitle: '',
              description: '',
            };
          });
        }
        dipatchNotification(
          updatedTaskResponse.type,
          updatedTaskResponse.message,
        );
        dispatch({
          type: RESET_DATE_RANGE,
        });
        handleClose();
      }
    } else {
      // Condition for form validation for submit new task
      if (dataValidation()) {
        const bodyPayload = createTaskBodyJSON(taskFormData);
        let isUnderQuota = true;
        if (
          bodyPayload.taskType === EXTERNAL ||
          bodyPayload.taskType === CLIENT_OFFICE ||
          bodyPayload.taskType === WORK_TRAVEL
        ) {
          isUnderQuota = await resolveQuotaCheck(bodyPayload, false);
        }
        if (!isUnderQuota) {
          setFieldError((prev) => {
            return { ...prev, timeDuration: true };
          });
          setErrorMsg((prev) => {
            return { ...prev, timeDuration: 'Exceeds Allotted Quota' };
          });
          return;
        }
        setLoadingApiCall(true);
        const createTaskResponse = await createTask(bodyPayload);
        setLoadingApiCall(false);
        if (createTaskResponse.isError === false) {
          handleClose();
          getTask();
          setPageNo(0);
          setPage(1);
        }
        dipatchNotification(
          createTaskResponse.type,
          createTaskResponse.message,
        );
        dispatch({
          type: RESET_DATE_RANGE,
        });
        handleClose();
      }
    }
  };

  const onBlur = (event) => {
    const value = event.target.value;
    const validatedTime = hourValidation(value);
    const formattedTime = getHHMMSSFromSeconds(validatedTime);
    setTime(formattedTime);
    setTimepickerField(formattedTime);
  };

  const onBlurMulti = (e, index, timingsIndex) => {
    let value = e.target.value;
    const time = hourValidation(value, index, timingsIndex);
    let newTasks = [...multipleTasks];
    newTasks[index].timings[timingsIndex].officeHours =
      getHHMMSSFromSeconds(time);
    setMultipleTasks(newTasks);
  };

  const handleTimeError = (timeError, timeErrorMsg, index, timingsIndex) => {
    let newTasks = multipleTasks;
    newTasks[index].timings[timingsIndex].timeError = timeError;
    newTasks[index].timings[timingsIndex].timeErrorMsg = timeErrorMsg;
    setMultipleTasks(newTasks);
  };

  const hourValidation = (value, index, timingsIndex) => {
    let sec = 0;
    if (value === null) {
      sec = 0;
    } else {
      sec = Math.max(0, getSecondsFromHHMMSS(value));
    }
    const secInADay = 23 * 60 * 60 + 59 * 60;
    setFieldError((prev) => {
      return { ...prev, timeDuration: false };
    });
    setErrorMsg((prev) => {
      return {
        ...prev,
        timeDuration: '',
      };
    });
    let hours = 0;
    let minutes = 0;
    if (value === null) {
      hours = 0;
      minutes = 0;
    } else {
      const [inputHours, inputMinutes] = value.split(':');
      hours = parseInt(inputHours, 10);
      minutes = parseInt(inputMinutes, 10);
    }
    // Convert the hours and minutes to numbers

    if (sec > secInADay || sec <= 0 || minutes > 59) {
      const newErrorMessage = TaskFieldError.INVALID_DURATION;
      setTimeErrorMsg(newErrorMessage);

      if (
        index == undefined ||
        index == null ||
        timingsIndex == null ||
        timingsIndex == undefined
      ) {
        setFieldError((prev) => {
          return { ...prev, timeDuration: true };
        });
        setErrorMsg((prev) => {
          return {
            ...prev,
            timeDuration: `${TaskFieldError.INVALID_DURATION}`,
          };
        });
      } else {
        handleTimeError(true, newErrorMessage, index, timingsIndex);
      }
      return 0;
    } else {
      if (index == undefined || index == null) {
        setFieldError((prev) => {
          return { ...prev, timeDuration: false };
        });
        setErrorMsg((prev) => {
          return {
            ...prev,
            timeDuration: '',
          };
        });
      } else {
        handleTimeError(false, '', index, timingsIndex);
      }
      return sec;
    }
  };

  const setTimingsError = (multipleTasks, index, timingsIndex) => {
    let newTasks = [...multipleTasks];
    newTasks[index].timings[timingsIndex].timeError = false;
    newTasks[index].timings[timingsIndex].timeErrorMsg = '';
    setMultipleTasks(newTasks);
  };

  React.useEffect(() => {
    if (editData?.employeeId) {
      setTaskFormData({
        ...taskFormData,
        ...{
          project: userProjects.find(
            (project) => project.projectId === editData.projectId,
          ).projectId,
          taskTitle: editData?.title,
          description: editData?.description,
          taskType: editData.taskType,
          startDate: editData.startDate,
          endDate: editData.endDate,
        },
      });
      dispatch({
        type: SET_DATE_RANGE,
        data: {
          startDate: new Date(editData.startDate).toISOString(),
          endDate: new Date(editData.endDate).toISOString(),
          key: '',
          color: MAIN_BLUE,
        },
      });
      if (editData.taskType === EXTERNAL) {
        const sec = editData.timings.map((item) => item.externalHours) / 1000;
        setTime(getHHMMSSFromSeconds(sec));
        setTimepickerField(getHHMMSSFromSeconds(sec));
      } else if (editData.taskType === CLIENT_OFFICE) {
        const sec =
          editData.timings.map((item) => item.clientOfficeHours) / 1000;
        setTime(getHHMMSSFromSeconds(sec));
        setTimepickerField(getHHMMSSFromSeconds(sec));
      } else if (editData.taskType === WORK_TRAVEL) {
        const sec =
          editData.timings.map((item) => item.workTravelHours) / 1000;
        setTime(getHHMMSSFromSeconds(sec));
        setTimepickerField(getHHMMSSFromSeconds(sec));
      } else if (editData.taskType === WFO) {
        let newTimeFieldEdit = [];
        let newTimings = editData.timings.map((timing) => {
          const newOfficeHours = getHHMMSSFromSeconds(
            timing.officeHours / 1000,
          );
          timing = { ...timing, officeHours: newOfficeHours };

          return timing;
        });
        const uniqueDates = [...new Set(newTimings.map((item) => item.date))];

        const updatedTasks = uniqueDates.map((date) => {
          const timings = newTimings
            .filter((item) => item.date === date)
            .map((item) => ({
              date: item.date,
              title: item?.title,
              description: item.description,
              officeHours: item.officeHours,
              wfhHours: item.wfhHours,
              externalHours: item.externalHours,
              timeError: false,
              timeErrorMsg: '',
              titleError: false,
              titleErrorMsg: '',
            }));

          return {
            date,
            timings,
          };
        });

        setMultipleTasks(updatedTasks);
      }

      setDateRange({
        startDate: editData.startDate,
        endDate: editData.endDate,
      });

      setAppraisal(editData.isAppraisal);
    }
  }, []);

  const onDateRangeSelection = (item) => {
    const dt = new Date(item.startDate);
    const enddate = new Date(item.endDate);
    let updatedData = [];
    let updatedTasks = [];
    while (dt <= enddate) {
      const element = [
        {
          date: moment(dt).format(YYYY_MM_DD),
          title: '',
          description: '',
          officeHours: null,
          wfhHours: 0,
          externalHours: 0,
          clientOfficeHours: 0,
          timeError: false,
          timeErrorMsg: '',
          titleError: false,
          titleErrorMsg: '',
        },
      ];
      updatedData = [...updatedData, ...element];
      updatedTasks = [
        ...updatedTasks,
        ...[{ date: moment(dt).format('YYYY-MM-DD'), timings: element }],
      ];
      dt.setDate(dt.getDate() + 1);
    }
    setWorkingHoursData(updatedData);
    setMultipleTasks(updatedTasks);
    let newTimeField = new Array(updatedData.length).fill(null);

    setTimepickerFieldMulti([...newTimeField]);

    setDateRange({
      ...{
        startDate: item.startDate,
        endDate: item.endDate,
      },
    });
  };

  const createTaskBodyJSON = (formBody) => {
    let updatedTasks = multipleTasks;
    if (formBody.taskType === WFO) {
      updatedTasks = multipleTasks.map((task) => {
        const updatedTimings = task.timings.map((timing) => {
          const seconds = getSecondsFromHHMMSS(timing.officeHours);
          timing.officeHours = seconds * 1000;
          return timing;
        });
        task.timings = updatedTimings;
        return task;
      });
    }
    const updatedTimings = updatedTasks.reduce((acc, task) => {
      return acc.concat(task.timings);
    }, []);
    const bodyJson = {
      employeeId: currentUserId,
      projectId: userProjects.find(
        (project) => project.projectId === formBody.project,
      ).projectId,
      startDate:
        formBody.taskType === WFO
          ? moment(dateRange.startDate).format(YYYY_MM_DD)
          : moment(currentDate.date.toString()).format(YYYY_MM_DD),
      endDate:
        formBody.taskType === WFO
          ? moment(dateRange.endDate).format(YYYY_MM_DD)
          : moment(currentDate.date.toString()).format(YYYY_MM_DD),
      title: formBody.taskTitle,
      description: formBody.description,
      taskType: formBody.taskType,
      timings:
        formBody.taskType === WFO
          ? updatedTimings
          : [
              {
                date: moment(currentDate.date.toString()).format(YYYY_MM_DD),
                wfhHours:
                  formBody.taskType === WFH
                    ? Math.max(0, getSecondsFromHHMMSS(time)) * 1000
                    : 0,
                externalHours:
                  formBody.taskType === EXTERNAL
                    ? Math.max(0, getSecondsFromHHMMSS(time)) * 1000
                    : 0,
                clientOfficeHours:
                  formBody.taskType === CLIENT_OFFICE
                    ? Math.max(0, getSecondsFromHHMMSS(time)) * 1000
                    : 0,
                workTravelHours:
                  formBody.taskType === WORK_TRAVEL
                    ? Math.max(0, getSecondsFromHHMMSS(time)) * 1000
                    : 0,
                officeHours: 0,
                title: formBody.taskTitle,
                description: formBody.description,
              },
            ],

      isAppraisal: appraisal,
    };
    if (userDataState.edit) {
      bodyJson.id = rows[userDataState.rowId].id;
      bodyJson.timings.map((item, index) => {
        editData.timings.map((obj, index2) => {
          if (index === index2) return (item.id = obj?.id);
        });
      });
    }
    return bodyJson;
  };

  return (
    <Container disableGutters>
      <Paper component={Box} elevation={0} p={4}>
        <Grid container>
          <Grid item md={12} mt={-2} xs={12}>
            <IconButton
              sx={{ mt: '0px', ml: '-8px' }}
              onClick={handleCancelForm}
            >
              <KeyboardBackspaceIcon />
            </IconButton>
            <FormGroup sx={{ float: 'right' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={handleOnChangeAppraisal}
                    checked={appraisal}
                  />
                }
                label={APPRAISAL}
              />
            </FormGroup>
          </Grid>
          <Grid container>
            <Grid item lg={7.5} md={7.5} xs={12}>
              <Grid item lg={7.5} md={7.5} sm={12} xs={12} sx={{ mb: '15px' }}>
                <FormControl fullWidth error={fieldError.project}>
                  <InputLabel id="taskProjectSelect">{PROJECT}</InputLabel>
                  <Select
                    name="project"
                    labelId="taskProjectSelect"
                    value={taskFormData.project}
                    label={PROJECT}
                    onChange={handleChangeForProject}
                  >
                    {userProjects.map((project) => (
                      <MenuItem value={project.projectId} key={project.id}>
                        {project.projectName}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errorMsg.project} </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item lg={7.5} md={7.5} sm={12} xs={12} sx={{ mb: '15px' }}>
                <FormControl fullWidth error={fieldError.taskType}>
                  <InputLabel id="taskTypeSelect">{TASK_TYPE}</InputLabel>
                  <Select
                    fullWidth
                    name="taskType"
                    labelId="taskTypeSelect"
                    value={taskFormData.taskType}
                    label={TASK_TYPE}
                    onChange={handleChangeForTaskType}
                    disabled={editData?.taskType}
                  >
                    {monthlyQuotaAllottedInMS > 0 && (
                      <MenuItem value={EXTERNAL}>{EXTERNAL_HOURS}</MenuItem>
                    )}
                    {clientOfficeMonthlyQuotaAllottedInMS > 0 && (
                      <MenuItem value={CLIENT_OFFICE}>
                        {CLIENT_OFFICE_HOURS}
                      </MenuItem>
                    )}
                    {workTravelMonthlyQuotaAllottedInMS > 0 && (
                      <MenuItem value={WORK_TRAVEL}>
                        {WORK_TRAVEL_HOURS}
                      </MenuItem>
                    )}
                  </Select>
                  <FormHelperText>{errorMsg.taskType} </FormHelperText>
                </FormControl>
              </Grid>

              <Grid item lg={7.5} md={7.5} sm={12} xs={12} sx={{ mb: '15px' }}>
                {taskFormData.taskType !== WFO ? (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      onViewChange={() => {
                        setFieldError((prev) => {
                          return { ...prev, timeDuration: false };
                        });
                        setErrorMsg((prev) => {
                          return {
                            ...prev,
                            timeDuration: '',
                          };
                        });
                      }}
                      PopperProps={{
                        sx: {
                          '& .css-1anqmj6-MuiPopper-root-MuiPickersPopper-root':
                            {
                              zIndex: 1300,
                              display: 'flex !important',
                              position: 'absolute !important',
                            },
                        },
                      }}
                      ampm={false}
                      label="Time"
                      value={getExternalTime()}
                      onChange={onChangeTime}
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          {...params}
                          onBlur={(e) => onBlur(e)}
                          autoComplete="off"
                          error={fieldError.timeDuration}
                          helperText={errorMsg.timeDuration}
                        />
                      )}
                    />
                  </LocalizationProvider>
                ) : (
                  <Box>
                    <TextField
                      name="taskTitle"
                      value={taskFormData.taskTitle}
                      onChange={handleChangeForTaskTitle}
                      label="Title"
                      fullWidth
                      inputProps={{ maxLength: 50 }}
                      error={fieldError.taskTitle}
                      helperText={errorMsg.taskTitle}
                    />
                    <div style={{ margin: '15px 0' }} />
                    <TextField
                      name="description"
                      value={taskFormData.description}
                      label="Description"
                      multiline
                      rows={4}
                      fullWidth
                      inputProps={{ maxLength: 300 }}
                      onChange={handleChangeForDescription}
                    />
                  </Box>
                )}
              </Grid>
            </Grid>
            {taskFormData.taskType === WFO ? (
              <Grid
                item
                md={4.5}
                error={dateRangeError}
                sx={{ height: '385px' }}
              >
                <DateRangeComponent
                  onDateRangeSelection={onDateRangeSelection}
                  editData={editData}
                  maxDate={new Date()}
                />
              </Grid>
            ) : (
              <Grid item md={4.5} error={dateError}>
                <TaskDatePicker
                  date={currentDate}
                  setDate={setCurrentDate}
                  editData={editData}
                />
              </Grid>
            )}
          </Grid>

          {taskFormData.taskType === WFO && (
            <Grid item md={12} xs={12} style={{ marginTop: 10 }}>
              {multipleTasks.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    paddingRight: '0.4rem',
                    paddingLeft: '0.4rem',
                    borderRadius: '0.3rem',
                    marginBottom: '0.8rem',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'row', md: 'row' },
                    }}
                  >
                    <Typography
                      sx={{
                        marginRight: { xs: 0, md: 3 },
                        marginTop: '0.6rem',
                      }}
                      size="small"
                    >
                      {moment(item.date).format('DD/MM/YYYY')}
                    </Typography>
                    <Tooltip title="Add a task">
                      <IconButton
                        sx={{ height: '2.5rem' }}
                        onClick={(event) => {
                          handleAddTasktoDate(event, index);
                        }}
                      >
                        <AddCircleIcon color="success" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  {multipleTasks[index].timings.map((item, timingsIndex) => (
                    <Box
                      sx={{
                        marginTop: '1rem',
                        padding: '0.5rem',
                        backgroundColor: 'rgba(0, 0, 0, 0.06)',
                        borderRadius: '0.3rem',
                      }}
                      key={timingsIndex}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: { xs: 'column', md: 'row' },
                        }}
                      >
                        <Box
                          sx={{
                            width: { xs: '100%', md: '30%' },
                            marginRight: { md: 2 },
                            marginBottom: { xs: 1 },
                          }}
                        >
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <TimePicker
                              PopperProps={{
                                sx: {
                                  '& .css-1anqmj6-MuiPopper-root-MuiPickersPopper-root':
                                    {
                                      zIndex: 1300,
                                      display: 'flex !important',
                                      position: 'absolute !important',
                                    },
                                },
                              }}
                              ampm={false}
                              label="Time"
                              onViewChange={() =>
                                setTimingsError(
                                  multipleTasks,
                                  index,
                                  timingsIndex,
                                )
                              }
                              value={getMultiTime(index, timingsIndex)}
                              onChange={(e) =>
                                handleChangeForRangeSelection(
                                  e,
                                  index,
                                  timingsIndex,
                                )
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  autoComplete="off"
                                  onBlur={(e) =>
                                    onBlurMulti(e, index, timingsIndex)
                                  }
                                  error={item.timeError}
                                  helperText={item.timeErrorMsg}
                                  size="small"
                                />
                              )}
                            />
                          </LocalizationProvider>
                        </Box>
                        <Box>
                          <TextField
                            name="taskTitle"
                            value={
                              multipleTasks[index].timings[timingsIndex]?.title
                            }
                            onChange={(event) => {
                              handleChangeForWFOTaskTitle(
                                event,
                                index,
                                timingsIndex,
                              );
                            }}
                            label={TASK_TILE}
                            size="small"
                            inputProps={{ maxLength: 50 }}
                            error={
                              multipleTasks[index].timings[timingsIndex]
                                ?.titleError
                            }
                            helperText={
                              multipleTasks[index].timings[timingsIndex]
                                ?.titleErrorMsg
                            }
                          />
                        </Box>
                        {multipleTasks[index].timings.length > 1 ? (
                          <Box sx={{ marginLeft: 'auto' }}>
                            <Tooltip title="Remove">
                              <IconButton
                                sx={{
                                  mr: '-0.2rem',
                                  mt: '-1.2rem',
                                  height: '1rem',
                                  width: '1rem',
                                  borderRadius: '0.3rem',
                                }}
                                onClick={(event) => {
                                  handleRemoveTask(event, index, timingsIndex);
                                }}
                              >
                                <CloseIcon color="black" fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        ) : null}
                      </Box>
                      <Box>
                        <TextField
                          name="description"
                          value={
                            multipleTasks[index].timings[timingsIndex]
                              .description
                          }
                          label={TASK_DESCRIPTION}
                          multiline
                          rows={2}
                          size="small"
                          inputProps={{ maxLength: 300 }}
                          onChange={(event) =>
                            handleChangeForWFOTaskDescription(
                              event,
                              index,
                              timingsIndex,
                            )
                          }
                        />
                      </Box>
                    </Box>
                  ))}
                </Box>
              ))}
            </Grid>
          )}
          {taskFormData.taskType !== WFO && (
            <>
              <Grid item md={12} xs={12} sx={{ mb: '15px' }}>
                <TextField
                  name="taskTitle"
                  value={taskFormData.taskTitle}
                  onChange={handleChangeForTaskTitle}
                  label={TASK_TILE}
                  fullWidth
                  inputProps={{ maxLength: 50 }}
                  error={fieldError.taskTitle}
                  helperText={errorMsg.taskTitle}
                />
              </Grid>

              <Grid container>
                <Grid item md={12} xs={12} sx={{ mb: '15px' }} sm={12}>
                  <TextField
                    name="description"
                    value={taskFormData.description}
                    label={TASK_DESCRIPTION}
                    multiline
                    rows={4}
                    fullWidth
                    inputProps={{ maxLength: 300 }}
                    onChange={handleChangeForDescription}
                  />
                </Grid>
              </Grid>
            </>
          )}

          <Grid container className="space-between-container">
            <Grid item>
              <Button
                onClick={handleCancelForm}
                variant="outlined"
                color={ERROR_KEY}
              >
                {CANCEL_BUTTON_TEXT}
              </Button>
            </Grid>
            <Grid item>
              <LoadingButton
                onClick={() => handleSubmitForTask()}
                loading={loadingApiCall}
                variant="contained"
              >
                {loadingApiCall ? 'loading...' : SUBMIT_BUTTON_TEXT}
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default TaskField;
